/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Allocation_LimitInputs */

const cs_billing_allocation_limit = /** @type {(inputs: Billing_Allocation_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit`)
};

const en_billing_allocation_limit = /** @type {(inputs: Billing_Allocation_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limit`)
};

/**
* | output |
* | --- |
* | "Limit" |
*
* @param {Billing_Allocation_LimitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_allocation_limit = /** @type {((inputs?: Billing_Allocation_LimitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Allocation_LimitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_allocation_limit(inputs)
	return cs_billing_allocation_limit(inputs)
});